import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";

import { Button, Input, RelodeTheme, Text } from "../";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            padding: 24,
            display: "flex",
            flexDirection: "column",
        },
        comment: {
            margin: theme.spacing(0, 0, 8, 0),
        },
        title: {
            marginBottom: 16,
        },
    });

interface FeedbackFormProps extends WithStyles<typeof styles> {
    username: string;
    onSendFeedback: (comment: string) => void;
    placeholder?: string;
}

interface FeedbackFormState {
    comment: string;
}

export const FeedbackForm = withStyles(styles, { name: "FeedbackForm" })(
    class extends React.Component<FeedbackFormProps, FeedbackFormState> {
        constructor(props: FeedbackFormProps) {
            super(props);
            this.state = {
                comment: "",
            };
        }

        handleSendClick = () => {
            const { onSendFeedback } = this.props;
            const { comment } = this.state;
            if (this.state.comment.length > 0 && onSendFeedback) onSendFeedback(comment);
            this.setState({ comment: "" });
        };

        handleCommentChange = evt => {
            this.setState({ comment: evt.target.value });
        };

        render() {
            const { comment } = this.state;
            const { classes } = this.props;
            const placeholder = !!this.props.placeholder
                ? this.props.placeholder
                : "where could we improve?  what did we knock out of the park?  something we could add to make your job easier?";
            return (
                <div className={classes.root}>
                    <Text className={classes.title} variant="body1">
                        send us some feedback
                    </Text>
                    <Input
                        autoFocus={true}
                        placeholder={placeholder}
                        label="comment"
                        className={classes.comment}
                        multiline={true}
                        rows={5}
                        value={comment}
                        onChange={this.handleCommentChange}
                        inputProps={{ maxLength: 255 }}
                    />
                    <Button variant="contained" size="small" color="primary" onClick={this.handleSendClick}>
                        send feedback
                    </Button>
                </div>
            );
        }
    }
);
